import { isNil } from "lodash";
import { createStore } from "zustand/vanilla";
import { gameRepo } from "./game";

let dialogId = 0;

export type TDialogButton = {
  label: string;
  callback?: (close: () => void) => void;
};

export type TDialog = {
  id: number;
  variant?: string;
  key?: string;
  title: string;
  text: string;
  style?: {
    title?: {
      fill?: string[];
      stroke?: string;
      strokeThickness?: number;
      fontFamily?: string;
    };
    text?: {
      fill?: string[];
      stroke?: string;
      strokeThickness?: number;
      fontFamily?: string;
    };
    button?: {
      fill?: string[];
      stroke?: string;
      strokeThickness?: number;
      fontFamily?: string;
    };
  };
  isOpen?: boolean;
  html?: string;
  isCloseable?: boolean;
  overlay?: boolean;
  buttons?: TDialogButton[];
};

export interface IDialogRepo {
  items: TDialog[];
  close: (closeId: number) => void;
  closeByKey: (closeKey?: string | null) => void;
  add: (dialog: TDialog) => void;
}

export const dialogRepo = createStore<IDialogRepo>((set, get) => {
  const close = (closeId: number) => {
    set(({ items }) => ({
      items: items.filter(({ id }) => id !== closeId),
    }));
  };

  const closeByKey = (closeKey?: string | null) => {
    if (isNil(closeKey)) {
      return set({
        items: [],
      });
    }

    set(({ items }) => ({
      items: items.filter(({ key }) => key !== closeKey),
    }));
  };

  const add = (dialog: TDialog) => {
    dialog.id = dialogId++;

    set(({ items }) => ({
      items: items.concat({
        overlay: true,
        ...dialog,
      }),
    }));
  };

  return {
    items: [],
    close,
    add,
    closeByKey,
  };
});

dialogRepo.subscribe(({ items }, p) => {
  if (
    (p.items.length === 0 && items.length === 1) ||
    (p.items.length === 1 && items.length === 0)
  ) {
    gameRepo.getState().send("dialogs_state", { value: items.length > 0 });
  }
});

export default dialogRepo;
